import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

export const getStreetsAvailable = async (values) => {
  return await request.get(
    `/TransportPermit/streets`,
    values,
    'При получении списка улиц произошла ошибка'
  );
};

const useStreetsAvailableQuery = (values, options) =>
  useQuery(
    queryKeys.streetsAvailable(values),
    () => getStreetsAvailable(values),
    options
  );

export default useStreetsAvailableQuery;
